var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.401,
    height: 46.276,
    viewBox: "0 0 28.401 46.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9",
    "data-name": "Rect\\xE1ngulo 9",
    width: 28.401,
    height: 46.276,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-368.599 -20.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(368.599 20.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M11.936,22.445c.046-.264.05-.352.211-1.353.624-3.9-3.914-6.412-3.914-6.412a7.744,7.744,0,0,0,5.184-6.822C13.7,3.263,8.491-3.011.023,1.633a.052.052,0,0,0-.011.076.053.053,0,0,0,.034.02.069.069,0,0,0,.043-.01A6.8,6.8,0,0,1,10.206,8.094a6.747,6.747,0,0,1-4.7,6.042c-.044.013-.042.065,0,.084,1.075.489,3.833,2.521,3.008,6.875-.054.288-.127.728-.159.912-1.449,8.278,7.9,10.732,7.9,10.732a10.29,10.29,0,0,1-4.315-10.3",
    transform: "translate(0 0)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M24.342,17.664a8.281,8.281,0,0,0-6.512,7.593c-.371,6.913,6.115,7.144,6.026,14.2a8.726,8.726,0,0,1-8,8.393.1.1,0,0,0-.02.2,10.063,10.063,0,0,0,11.8-9.163c.665-6.832-6.068-9.464-5.816-14.28.2-3.823,2.624-6.927,8.3-6.722a.047.047,0,0,0,.01-.092,17.535,17.535,0,0,0-5.779-.128",
    transform: "translate(-1.757 -1.947)",
    fill: "#987744"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9932bfe69036a39dfe551f5f04298714.svg";
export { ForwardRef as ReactComponent };